import { Box, Modal } from "@mui/material";
import { FormModalProps } from "../../utils/types";

export const FormModal = (props: FormModalProps) => {
    const { Form, show, close, title } = props;
    return (
        <Modal open={show} onBackdropClick={close}>
            <Box
                id="login-modal"
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "25vw",
                    minHeight: "25vh",
                    position: "absolute" as "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)"
                }}
            >
                <div className="modal">
                    <div style={{ padding: "0 20px" }}>
                        <h2>{title}</h2>
                    </div>
                    {Form}
                </div>
            </Box>
        </Modal>
    );
};
